/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Placeholder_TokenInputs */

const fr_placeholder_token = /** @type {(inputs: Placeholder_TokenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Token statique Directus`)
};

const en_placeholder_token = /** @type {(inputs: Placeholder_TokenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Directus static token`)
};

/**
* | output |
* | --- |
* | "Directus static token" |
*
* @param {Placeholder_TokenInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const placeholder_token = /** @type {((inputs?: Placeholder_TokenInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Placeholder_TokenInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_placeholder_token(inputs)
	return en_placeholder_token(inputs)
});